// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","username":"Header_username__oxmRT"};